<template>
  <div class="custom-no-header">
    <slot />
  </div>
</template>
